module.exports = __webpack_public_path__ + "static/media/ball22x.6225c91d.png";